// src/utils/notificationTypeMeta.js
// S14c: mapa de metadatos por `type` de `notifications/` — extraído de Layout.js para
// no duplicarlo en /mi-cuenta/mensajes/.

export function getNotificationTypeMeta(type, t) {
  const META = {
    mentor_feedback: { chip: 'sage', chipLabel: t('notifications.chipFeedback'), href: '/mi-cuenta/mensajes/' },
    note_feedback: { chip: 'sage', chipLabel: t('notifications.chipFeedback'), href: '/mi-cuenta/mensajes/' },
    lesson_ack: { chip: 'sage', chipLabel: t('notifications.chipFeedback'), href: '/mi-cuenta/mensajes/' },
    session_reminder: { chip: 'forest', chipLabel: t('notifications.chipSession'), href: '/mi-cuenta/mensajes/' },
    welcome: { chip: 'gold', chipLabel: t('notifications.chipWelcome'), href: '/mi-cuenta/' },
    lesson_completed: { chip: 'gold', chipLabel: t('notifications.chipLesson'), href: '/mentor/' },
    program_milestone: { chip: 'gold', chipLabel: t('notifications.chipMilestone'), href: '/mentor/' },
  };
  return META[type] || { chip: 'forest', chipLabel: t('notifications.chipFeedback'), href: '/mi-cuenta/mensajes/' };
}
